export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"a\" d=\"M9 18H2V6h7v12zm2-12v12l11 6V0L11 6z\"/></svg>";